export const payFrequency = {
  MONTHLY: 'MENSUAL', BIMONTHLY: 'BIMESTRAL', QUARTERLY: 'TRIMESTRAL', BIANNUAL: 'SEMESTRAL', BULLET: 'Último período',
};
